import { useTheme } from 'styled-components'

import ReturnPortalSelector from '@/common/components/PageLayout/Header/ReturnPortalSelector/ReturnPortalSelector'

import Option from './Option/Option'
import * as Styles from './styles'

const MenuOptions = ({
  options = [],
  currentPath,
  returnPortals,
  onChangeReturnPortal,
  selectedReturnPortal,
  showMenu,
}) => {
  const theme = useTheme()
  const merchantOptions = options.filter(option => option.visible && option.isMerchantOption)
  const storeOptions = options.filter(option => option.visible && !option.isMerchantOption)

  return (
    <Styles.MenuOptionsContainer showMenu={showMenu}>
      <nav>
        {merchantOptions.length > 0 && (
          <Styles.MerchantSection>
            <Styles.List data-cy="sidebar-menu">
              {merchantOptions.map((option, index) => (
                <Option key={index} option={option} currentPath={currentPath} />
              ))}
            </Styles.List>
            <Styles.CustomDivider />
          </Styles.MerchantSection>
        )}
        <Styles.List color={theme.colors.text.inverse}>
          <li>
            <ReturnPortalSelector
              onChangeReturnPortal={onChangeReturnPortal}
              returnPortals={returnPortals}
              selectedReturnPortal={selectedReturnPortal}
              showMenu={showMenu}
            />
          </li>
          {storeOptions.map((option, index) => (
            <Option key={index} option={option} currentPath={currentPath} />
          ))}
        </Styles.List>
      </nav>
    </Styles.MenuOptionsContainer>
  )
}

export default MenuOptions
